import { baseUrl, isSignedIn, getHeaders } from "@services/AuthServices";
import {queryFilter} from "@/filters/query-filter";

export async function GetDocumentationFiles(entityId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/wasteManagement/documentation/${entityId}/getFiles`;

    return axios.get(urlApi, getHeaders(true));
}

export async function DeleteDocumentationFile(entityId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/wasteManagement/documentation/${entityId}/deleteFile`;

    return axios.delete(urlApi, {
        data: body,
        headers: getHeaders().headers,
    });
}

export async function UploadDocumentationFile(entityId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/wasteManagement/documentation/${entityId}/uploadFile`;

    return axios.post(urlApi, body, getHeaders());
}

export async function GetDocumentationEntities(entityId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/SILiAmb/wasteManagement/documentation/entities/${entityId}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function ExportSILiAmbMetrics(tableFilters) {
    await isSignedIn();

    const query = queryFilter(tableFilters);
    const urlApi = `${baseUrl}/SILiAmb/export${query}`;

    return axios.get(urlApi, {...getHeaders(), responseType: "blob"});
}

export async function EnvironmentalDocServicesGetSILiAmbContainerTypes() {
  await isSignedIn();

  const urlApi = `${baseUrl}/SILiAmb/container-types`;

  return axios.get(urlApi, getHeaders(true));
}